
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentcolor","d":"M17 6a2 2 0 11-3.999.001A2 2 0 0117 6zm0 6a2 2 0 11-3.999.001A2 2 0 0117 12zm0 6a2 2 0 11-3.999.001A2 2 0 0117 18zM11 6a2 2 0 11-3.999.001A2 2 0 0111 6zm0 6a2 2 0 11-3.999.001A2 2 0 0111 12zm0 6a2 2 0 11-3.999.001A2 2 0 0111 18z"}})])
          )
        }
      }
    